import REQUEST from "@/assets/js/request"
// const urlData ="http://192.168.22.227:9100"
// const urlData ="https://xzfbtest.xzyunchuang.com/prod-api"
const urlData ="https://www.xuzhoufabu.com/prod-api"
// 首页轮播
export const indexBanner = (DATA) => {
  return REQUEST({
    url: urlData+'/xzfb/indexBanner',
    data: DATA,
    method: 'get'
  })
}
// 往期回顾前6
export const latestNews = (DATA) => {
  return REQUEST({
    url: urlData+'/xzfb/latestNews',
    data: DATA,
    method: 'get'
  })
}
// 往期回顾前
export const articleList = (DATA) => {
  return REQUEST({
    url: urlData+'/xzfb/articleList',
    params: DATA,
    method: 'get'
  })
}
// 详情http://192.168.22.227:9100/xzfb/detail
export const detail = (DATA) => {
  return REQUEST({
    url: urlData+'/xzfb/detail',
    params: DATA,
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js